<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="480"
    transition="dialog-bottom-transition"
  >
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card class="glass-card pa-6 rounded-xl" dark>
        <!-- Header -->
        <div class="d-flex align-center mb-5">
          <v-icon color="success" large class="mr-3"> mdi-lock-reset </v-icon>

          <div>
            <div class="text-h6 font-weight-bold d-flex">
              Cambiar contraseña
            </div>
            <div class="caption">Actualizá tu contraseña de acceso</div>
          </div>

          <v-spacer />

          <v-btn icon @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <!-- Usuario -->
        <v-text-field
          :value="usuario"
          prepend-inner-icon="mdi-account"
          label="Usuario"
          outlined
          dense
          disabled
        />

        <!-- Pass actual -->
        <v-text-field
          v-model="pass"
          prepend-inner-icon="mdi-lock"
          :rules="requiredRules"
          label="Contraseña actual"
          type="password"
          outlined
          dense
          required
        />

        <!-- Pass nueva -->
        <v-text-field
          v-model="passNuevo"
          prepend-inner-icon="mdi-lock-plus"
          label="Contraseña nueva"
          type="password"
          outlined
          dense
          required
          maxlength="30"
          @blur="$v.passNuevo.$touch()"
        />

        <!-- Repetir -->
        <v-text-field
          v-model="passNuevoRepetir"
          prepend-inner-icon="mdi-lock-check"
          label="Repetir contraseña"
          type="password"
          outlined
          dense
          required
          maxlength="30"
          @blur="$v.passNuevoRepetir.$touch()"
        />

        <!-- Validaciones -->
        <div class="mt-2">
          <div v-show="!$v.passNuevoRepetir.sameAs" class="caption error--text">
            Las contraseñas no coinciden
          </div>

          <div v-show="!$v.passNuevo.minLen" class="caption error--text">
            Mínimo 6 caracteres
          </div>
        </div>

        <!-- Actions -->
        <v-card-actions class="px-0 pt-6">
          <v-btn
            block
            large
            color="success"
            :disabled="!valid || $v.$invalid"
            @click.stop="modificarContrasena"
          >
            Guardar cambios
          </v-btn>
        </v-card-actions>

        <v-btn
          text
          small
          block
          color="grey lighten-2"
          class="mt-2"
          @click.stop="show = false"
        >
          Cancelar
        </v-btn>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import axios from "@/axios-auth";
import { required, minLength, sameAs } from "vuelidate/lib/validators";
import { showAlert } from "@/utils/toast";

export default {
  data: (vm) => ({
    valid: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    pass: "",
    passNuevo: "",
    passNuevoRepetir: "",
    idUsuarioPaciente: "",
  }),
  props: ["visible", "usu"],
  computed: {
    show: {
      get() {
        this.idUsuarioPaciente = this.$store.state.idUsuarioPaciente;
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          this.vaciarModels();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
    usuario: {
      get() {
        return this.usu;
      },
    },
  },
  methods: {
    vaciarModels() {
      (this.pass = ""), (this.passNuevo = ""), (this.passNuevoRepetir = "");
    },
    modificarContrasena() {
      this.$swal({
        title: "Modificar Contraseña",
        text: "¿Desea modificar la contraseña?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          const datosUsuario = {
            pass: this.pass,
            passNuevo: this.passNuevo,
            idUsuarioPaciente: this.idUsuarioPaciente,
          };

          let self = this;
          axios
            .get("/Usuario/CambiarPassUsuarioPaciente?", {
              params: {
                pass: datosUsuario.pass,
                passNuevo: datosUsuario.passNuevo,
                idUsuarioPaciente: datosUsuario.idUsuarioPaciente,
              },
            })
            .then((response) => {
              if (response.data == "incorrecta") {
                self.showAlert({
                  icon: "warning",
                  title: "Contraseña actual incorrecta.",
                  vm: self,
                  timer: 2000,
                });
              } else {
                self.$refs.form.resetValidation();
                self.vaciarModels();
                document.getElementsByClassName(
                  "v-dialog--active",
                )[0].scrollTop = 0;
                self.showAlert({
                  icon: "success",
                  title: "Contraseña modificada con éxito.",
                  vm: self,
                  timer: 2000,
                });
                self.$emit("close");
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "warning",
                title: "La contraseña no pudo ser modificada.",
                vm: this,
                timer: 2000,
              });
            });
        }
      });
    },
    showAlert(alertInfo) {
      showAlert(alertInfo);
    },
  },
  validations: {
    passNuevo: {
      required,
      minLen: minLength(6),
    },
    passNuevoRepetir: {
      //sameAs: sameAs('password')
      sameAs: sameAs((vm) => {
        return vm.passNuevo;
      }),
    },
  },
};
</script>
<style scoped>
.glass-card {
  backdrop-filter: blur(10px);
  background: rgba(20, 35, 45, 0.88);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.35);
}
</style>
